<template>
    <filters-wrapper :has-active-filters="props.hasActiveFilters" @submit="emit('submit')" @reset="emit('reset')">
        <template v-slot:panel>
            <FilterStatusToggle v-model="filters.active" @update:model-value="emit('submit')" />
        </template>
        <v-form class="table-filters">
            <v-row dense>
                <v-col cols="12" sm="4" md="3">
                    <v-text-field
                        v-model="filters.name"
                        :label="$t('name')"
                        hide-details
                        density="compact"
                        variant="outlined"
                        color="primary"
                        data-cy="name"
                        class="mb-4"
                    />
                </v-col>
            </v-row>
        </v-form>
    </filters-wrapper>
</template>

<script setup lang="ts">
    const props = defineProps<{
        hasActiveFilters: boolean
    }>()

    const filters = defineModel<any>()
    const emit = defineEmits<{
        (e: 'submit' | 'reset'): void
    }>()
</script>
